import { OTCDerivatives } from '@src/containers/Blotters/OTC/OTCDerivatives/OTCDerivatives';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { OTCDerivativesBlotterPanelConfig } from '../../../../../types/LayoutConfig';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function OTCDerivativesPanel({ params, api }: LayoutPanelProps<OTCDerivativesBlotterPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.OTCDerivativesBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="otc-derivatives-panel"
      >
        <OTCDerivatives />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
